import { get } from "lodash-es";
import { routes } from "configs";
import { generatePath } from "utils";
import { RootState } from "configs/store/types";
import { FetchedStandard, StandardScope } from "./types";

export const getStandardById =
  (id: string) =>
  (state: RootState): FetchedStandard =>
    state.standards.byId[id];

export const getStandardChildren = (
  standard: FetchedStandard,
): StandardScope[] => {
  const byScope: {
    [key: string]: StandardScope;
  } = {};

  const elementIdsWithElementParts: { [key: string]: boolean } = {};

  standard.elements.forEach((element) => {
    if (!byScope[element.scopeId]) {
      const { name, id } = element.scope;
      byScope[element.scopeId] = {
        id,
        name,
        elements: [],
        elementParts: [],
      };
    }
    byScope[element.scopeId].elements.push(element);
  });
  standard.elementParts.forEach((elementPart) => {
    if (!byScope[elementPart.element.scopeId]) {
      const { name, id } = elementPart.element.scope;
      byScope[elementPart.element.scopeId] = {
        id,
        name,
        elements: [],
        elementParts: [],
      };
    }
    elementIdsWithElementParts[elementPart.element.id] = true;
    byScope[elementPart.element.scopeId].elementParts.push(elementPart);
  });

  return Object.keys(byScope).map((key) => ({
    ...byScope[key],
    elements: byScope[key].elements.filter(
      (element) => !elementIdsWithElementParts[element.id],
    ),
  }));
};

export const getBreadcrumbs = (
  standard: FetchedStandard,
): { label: string; link: string }[] => [
  ...standard.standardBreadcrumbs.map(({ id: breadcrumbId, name }) => ({
    label: name,
    link: generatePath(routes.standards, {
      standardId: breadcrumbId,
    }),
  })),
  {
    label: standard.name,
    link: generatePath(routes.standards, {
      standardId: standard.id,
    }),
  },
];

export const isStandardEmpty = (standard: FetchedStandard): boolean =>
  !(
    get(standard, "elementParts.length") ||
    get(standard, "elements.length") ||
    get(standard, "standardIds.length")
  );

export const prepareStandards = (
  standards: FetchedStandard[],
): FetchedStandard[] =>
  standards
    .filter((standard) => !(standard.deleted || standard.disabled))
    .sort((prev, next) => prev.position - next.position);
